import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { restartSubscriptionsClient } from './apollo.link.js';

@Injectable({ providedIn: 'root' })
export class ApolloAddon {
  constructor(private apollo: Apollo) { }

  resetWsConnection() {
    restartSubscriptionsClient();
  }


  async clearStore() {
    await this.apollo.client.clearStore();
  }
}
